import React, {useState}							from 'react';
import {CheckboxProps}								from './interface';

import Icon											from '../Icon';

import img_check									from '../../images/icon/check.svg';

import './Checkbox.css';


function Checkbox(props: CheckboxProps) {
	const [isFocused, set_isFocused] = useState(false);
	const style: React.CSSProperties = props.style || {};

	const onClick = () => {
		if (!props.readOnly && props.onChange)
			props.onChange(!props.active);
	};

	const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (event.key === 'Enter' && isFocused && !props.readOnly)
			onClick();
	};

	if (props.size) {
		style.minWidth = props.size;
		style.minHeight = props.size;
		style.maxWidth = props.size;
		style.maxHeight = props.size;
	}

	function renderActive() {
		if (props.round)
			return <div />;

		return (
			<Icon
				icon={img_check}
				iconColor={props.readOnly ? '#D0D5DD' : undefined}
				iconSize={props.size ? props.size * 0.7 : undefined}
			/>
		);
	}

	return (
		<div className={'checkboxContainer'} onClick={onClick}>
			<div
				tabIndex={0}
				style={style}
				role={'checkbox'}
				onKeyDown={handleKeyDown}
				aria-checked={props.active || false}
				onFocus={() => set_isFocused(true)}
				onBlur={() => set_isFocused(false)}
				className={`checkbox ${props.active && 'active'} ${props.readOnly && 'readOnly'} ${props.round && 'round'}`}
			>
				{props.active && renderActive()}
			</div>
			{props.text && <span>{props.text}</span>}
		</div>
	);
}

export default Checkbox;